import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class ProductSelectionService {
    constructor(private http: HttpClient) {}

    getAllProductsChannel(name): Observable<any> {
        return this.http.get<any>(
            `${environment.configUrl}Configuration/Name?name=${name}`
        );
    }

    getWarehouseWiseProduct(typeId, pageNo, pageSize, searchValue, locationId, accountId) {
        let params = new HttpParams();
        params = params.append("warehouseId", locationId);
        params = !accountId ? params : params.append("accountId", accountId);
        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !searchValue ? params : params.append("search", searchValue);
        return this.http
            .get<any>(
                `${environment.inventoryURl}Product/GetWarehouseWiseProduct?typeId=${typeId}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getWarehouseWiseProductBarcode(data) {
        // console.log(data);
        let params = new HttpParams();
        params = !data.locationId ? params : params.append("warehouseId", data.locationId);
        params = !data.accountId ? params : params.append("accountId", data.accountId);
        params = !data.pageNumber ? params : params.append("PageNumber", data.pageNumber);
        params = !data.pageSize ? params : params.append("PageSize", data.pageSize);
        params = !data.searchValue ? params : params.append("searchValue", data.searchValue);
        return this.http
            .get<any>(
                `${environment.inventoryURl}Product/GetWarehouseWiseProductBarcode?typeId=${data.typeId}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllWarehouse(pageNo, pageSize, isAscending) {
        let params = new HttpParams();
        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        return this.http
            .get<any>(`${environment.inventoryURl}Warehouse`, {
                observe: "response",
                params,
            })
            .toPromise()
            .then((res) => ({
                wareHouses: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllLocations(pageNo, pageSize, searchValue) {
        let params = new HttpParams();
        params = params.append("PageNumber", pageNo);
        params = params.append("PageSize", pageSize);
        params = params.append("SearchValue", searchValue);
        return this.http.get<any>(
            `${environment.inventoryURl}WareHouse/AllWarehouseDetails`,
            { params }
        );
    }

    getProductVisibilityData(obj) {
        return this.http.post<any>(`${environment.inventoryURl}Product/ProductPagedListByFilter`, obj, { observe: 'response' }).pipe(
          map((res: HttpResponse<any>) => {
            return {
              inventory: res.body,
              headers: JSON.parse(res.headers.get('x-pagination'))
            };
          })
        );
      }
}
